import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  ReactNode,
} from 'react';

import FullScreenLoader from './FullScreenLoader';

interface LoaderContextType {
  showLoader: () => void;
  hideLoader: () => void;
  loading: boolean;
}

const LoaderContext =
  createContext<LoaderContextType | null>(
    null
  );

interface Props {
  children: ReactNode;
}

export const LoaderProvider = ({
  children,
}: Props) => {
  const [loading, setLoading] =
    useState(false);

  const showLoader = useCallback(() => {
    setLoading(true);
  }, []);

  const hideLoader = useCallback(() => {
    setLoading(false);
  }, []);

  const value = useMemo(
    () => ({
      loading,
      showLoader,
      hideLoader,
    }),
    [
      loading,
      showLoader,
      hideLoader,
    ]
  );

  return (
    <LoaderContext.Provider
      value={value}
    >
      {children}

      {loading && (
        <FullScreenLoader />
      )}
    </LoaderContext.Provider>
  );
};

export const useLoaderContext = () => {
  const context = useContext(
    LoaderContext
  );

  if (!context) {
    throw new Error(
      'useLoaderContext must be used inside LoaderProvider'
    );
  }

  return context;
};